
class Savings
{
	constructor()
	{
		this.options = [];
		this.events();
	}

	events()
	{
		var obj = this;

		$("#listView").click(function()
		{
			$("#savingsOptions")
			.removeClass("gridLayout")
			.attr("data-layout", "list");
		});

		$("#gridView").click(function()
		{
			$("#savingsOptions")
			.addClass("gridLayout")
			.attr("data-layout", "grid");
		});

		$("#sortRate").click(function()
		{
			// existing order
			var sortOrder = $("#savingsOptions").data("sort");

			obj.options.sort(function(a, b)
			{
				if (sortOrder == "asc")
				{
					return  a.coin.rate - b.coin.rate;
				}
				else
				{
					return b.coin.rate - a.coin.rate;
				}
			});

			obj.buildOptionList();

			// save new order
			var sort = "desc";
			if ($("#savingsOptions").data("sort") == "desc")
			{
				sort = "asc";
			}

			$("#savingsOptions").data("sort", sort);
		});

		$("#search").on("keyup change", function()
		{
			var search = $(this).val().toUpperCase();

			for (var i = 0; i < obj.options.length; ++i)
			{
				if ((obj.options[i].coin.ticker.toUpperCase().indexOf(search) > -1) ||
					(obj.options[i].coin.name.toUpperCase().indexOf(search) > -1))
				{
					$(".option_" + obj.options[i].coin.id).removeClass("hide");
				}
				else
				{
					$(".option_" + obj.options[i].coin.id).addClass("hide");
				}
			}
		});

		$("#earingOnly").click(function()
		{
			var enable = $(this).is(":checked");

			for (var i = 0; i < obj.options.length; ++i)
			{
				if (enable)
				{
					if (obj.options[i].user.principal > 0)
					{
						$(".option_" + obj.options[i].coin.id).removeClass("hide");
					}
					else
					{
						$(".option_" + obj.options[i].coin.id).addClass("hide");
					}
				}
				else
				{
					$(".option_" + obj.options[i].coin.id).removeClass("hide");
				}
			}
		});

		$(document).on("click", ".controlUserViews", function()
		{
			var ID = $(this).data("id");
			$(".userViews" + ID).toggle();
		});

		$(document).on("click", ".savingsInfo", function()
		{
			Misc.message($(this).data("ticker") + " Easy Save", $(this).data("info"), "info");
		});

		$(document).on("click", ".useMax", function()
		{
			$("#principal_" + $(this).data("option")).val($(this).data("available"));
		});

		$(document).on('propertychange change paste keyup input', '.addAmount', function()
		{
			var amount = Misc.cleanNumber($(this).val());
			$(this).val(amount);
		});

		$(document).on("click", ".addFunds", function()
		{
			var error = "";
			var button = this;
			var optionID = $(this).data("id");
			var random = $(this).data("random");
			var csrf = $(".option_" + optionID).data("csrf");

			var ticker = $(this).data("ticker");
			var amount = parseFloat(Misc.cleanNumber($("#principal_" + optionID).val()));
			var minimum = parseFloat(Misc.cleanNumber($("#principal_" + optionID).data("minimum")));
			var maximum = parseFloat(Misc.cleanNumber($("#principal_" + optionID).data("maximum")));

			// validate
			if ((amount < minimum) ||
				(amount > maximum))
			{
				error = "Please enter an amount between<br />" + minimum + " - " + maximum + " " + ticker;
			}

			if (!$("#agreed_" + optionID).is(":checked"))
			{
				error += (error != "") ? "<br />" : "";
				error += "Please agree to the terms and conditions";
			}

			if (error != "")
			{
				Misc.errorMessage(error);
				return;
			}

			Misc.confirmMessage("Add Funds", "Are you sure you want to add funds?", "question")
			.then((result) =>
			{
				if (result.value)
				{
					obj.addFunds(optionID, amount, random, csrf, button);
				}
			});
		});

		$(document).on("click", ".claimRewards", function()
		{
			var error = "";
			var button = this;
			var optionID = $(this).data("id");
			var random = $(this).data("random");
			var csrf = $(".option_" + optionID).data("csrf");

			var ticker = $(this).data("ticker");
			var minimum = parseFloat(Misc.cleanNumber($(this).data("minimum")));

			// minimum requirements
			var rewards = parseFloat(Misc.cleanNumber($(this).data("rewards")));
			if (rewards < minimum)
			{
				error = "The minimum reward claim is " + minimum + " " + ticker;
			}

			if (error != "")
			{
				Misc.errorMessage(error);
				return;
			}

			// calculate wait
			var claimLimit = $(this).data("limit");
			var claimTimeFrame = claimLimit + " minutes";
			var claimSeconds = claimLimit * 60;
			if (claimLimit > 60)
			{
				claimTimeFrame = (claimLimit / 60) + " hours";
			}

			Misc.confirmMessage("Claim Rewards", "Claimed rewards will be deposited into your wallet.<br /><br />You will have to wait " + claimTimeFrame + " before you can claim again.", "question")
			.then((result) =>
			{
				if (result.value)
				{
					obj.claimRewards(optionID, random, csrf, button);
				}
			});
		});

		$(document).on("click", ".claimExit", function()
		{
			var button = this;
			var optionID = $(this).data("id");
			var random = $(this).data("random");
			var csrf = $(".option_" + optionID).data("csrf");

			// calculate wait
			var claimLimit = $(this).data("limit");
			var claimTimeFrame = claimLimit + " minutes";
			var claimSeconds = claimLimit * 60;
			if (claimLimit > 60)
			{
				claimTimeFrame = (claimLimit / 60) + " hours";
			}

			Misc.confirmMessage("Claim & Exit", "Capital and rewards will be deposited into your wallet and the savings account closed.<br /><br />You will have to wait " + claimTimeFrame + " before you can claim again.", "question")
			.then((result) =>
			{
				if (result.value)
				{
					obj.claimExit(optionID, random, csrf, button);
				}
			});
		});
	}

	buildOptionList()
	{
		var obj = this;

		$("#savingsOptions").html("");

		for (var i = 0; i < this.options.length; ++i)
		{
			// don't show ended options unless containing principal
			if ((this.options[i].status.id == 3) && (this.options[i].user.principal == 0))
			{
				continue;
			}

			var template = $("#optionTemplate").html();

			// limit user access
			if (this.options[i].user.limited == 1)
			{
				template = template.replaceAll("{STATUS_JOIN}", "hide");
				template = template.replaceAll("{STATUS_LOCKED}", "");
				template = template.replaceAll("{STATUS_SHOW_MORE}", "hide");
				template = template.replaceAll("{STATUS_AVAILABLE}", "hide");
				template = template.replaceAll("{STATUS_EARNINGS}", "hide");
			}

			// styling
			template = template.replaceAll("{STYLE_BORDER}", this.options[i].style.border);

			// details
			template = template.replaceAll("{COIN_ID}", this.options[i].coin.id);
			template = template.replaceAll("{COIN_TICKER}", this.options[i].coin.ticker);
			template = template.replaceAll("{COIN_NAME}", this.options[i].coin.name);
			template = template.replaceAll("{COIN_IMAGE}", this.options[i].coin.image);
			template = template.replaceAll("{COIN_RATE}", Misc.formatCurrency(this.options[i].coin.rate, 2));
			template = template.replaceAll("{COIN_INFO}", this.options[i].coin.info);
			template = template.replaceAll("{COIN_SEARCH}", this.options[i].coin.ticker + " " + this.options[i].coin.name);
			template = template.replaceAll("{COIN_RANDOM}", this.options[i].coin.random);

			// controls
			template = template.replaceAll("{ADD_MINIMUM}", this.options[i].coin.add_minimum);
			template = template.replaceAll("{ADD_MAXIMUM}", this.options[i].coin.add_maximum);
			template = template.replaceAll("{CLAIM_MINIMUM}", this.options[i].coin.claim_minimum);
			template = template.replaceAll("{CLAIM_MINUTES}", this.options[i].coin.claim_minutes);

			// status
			var color = "text-success";
			switch (this.options[i].status.id)
			{
				case 2:
					color = "text-info";
					break;
				case 3:
					color = "text-danger";
					break;
			}

			template = template.replaceAll("{STATUS_TAG}", this.options[i].status.tag);

			if (this.options[i].status.id == 3)
			{
				template = template.replaceAll("{STATUS_MESSAGE}", "<small class='px-1 py-1 mr-0 " + color + "'>" + this.options[i].status.name + " - " + Misc.formatDate(this.options[i].status.date) + "</small>");
			}
			else
			{
				template = template.replaceAll("{STATUS_MESSAGE}", "");
			}

			// security
			template = template.replaceAll("{CSRF_TOKEN}", this.options[i].user.csrf);

			// available
			if (this.options[i].user.available > 0)
			{
				if (this.options[i].status.id != 3)
				{
					// amounts
					template = template.replaceAll("{STYLE_GLOW}", this.options[i].coin.ticker.toLowerCase() + "-glow");
					template = template.replaceAll("{USER_AVAILABLE}", Misc.formatCurrency(this.options[i].user.available, 8));
					template = template.replaceAll("{USER_AVAILABLE_RAW}", this.options[i].user.available);
				}
				else
				{
					template = template.replaceAll("{STATUS_AVAILABLE}", "hide");
				}
			}
			else
			{
				template = template.replaceAll("{USER_AVAILABLE}", 0);
				template = template.replaceAll("{USER_AVAILABLE_RAW}", 0);
			}

			if (this.options[i].status.id != 2)
			{
				// earnings
				if (this.options[i].user.principal > 0)
				{
					template = template.replaceAll("{STYLE_GLOW}", this.options[i].coin.ticker.toLowerCase() + "-glow");

					template = template.replaceAll("{USER_PRINCIPAL}", Misc.formatCurrency(this.options[i].user.principal, 8));
					template = template.replaceAll("{USER_REWARD}", Misc.formatCurrency(this.options[i].user.reward, 8));
					template = template.replaceAll("{USER_ZAR_EQUIV}", Misc.formatCurrency(this.options[i].user.zar_equiv, 2));
				}
				else
				{
					template = template.replaceAll("{STYLE_GLOW}", "");
					template = template.replaceAll("{STATUS_EARNINGS}", "hide");
				}

				// join
				if ((this.options[i].user.active == 1) && (this.options[i].user.limited == 0))
				{
					template = template.replaceAll("{JOIN_MESSAGE}", "");
					template = template.replaceAll("{STATUS_JOIN}", "hide");
					template = template.replaceAll("{STATUS_LOCKED}", "hide");
					template = template.replaceAll("{STATUS_SHOW_MORE}", "show");
					template = template.replaceAll("{STATUS_AVAILABLE}", "");
					template = template.replaceAll("{STATUS_EARNINGS}", "");
				}
				else
				{
					template = template.replaceAll("{JOIN_MESSAGE}", "Login to Save");
					template = template.replaceAll("{STATUS_JOIN}", "");
					template = template.replaceAll("{STATUS_LOCKED}", "hide");
					template = template.replaceAll("{STATUS_SHOW_MORE}", "hide");
					template = template.replaceAll("{STATUS_AVAILABLE}", "hide");
					template = template.replaceAll("{STATUS_EARNINGS}", "hide");
				}
			}
			else
			{
				template = template.replaceAll("{JOIN_MESSAGE}", this.options[i].status.name + " - " + Misc.formatDate(this.options[i].status.date));
				template = template.replaceAll("{STATUS_JOIN}", "");
				template = template.replaceAll("{STATUS_LOCKED}", "hide");
				template = template.replaceAll("{STATUS_SHOW_MORE}", "hide");
				template = template.replaceAll("{STATUS_AVAILABLE}", "hide");
				template = template.replaceAll("{STATUS_EARNINGS}", "hide");
			}

			$("#savingsOptions").append(template);

			// filters
			if (this.options[0].user.active == 1)
			{
				$("#userFilters").removeClass("hide");
			}
		}
	}

	loadOptions()
	{
		var obj = this;

		$("#pageLoading").show();

		Security.AJAX(
			"/services/savings/options.php",
			{},
			"POST",
			function(data)
			{
				if (data.Error.Code == 0)
				{
					if (data.Maintenance)
					{
						$("#maintenance").removeClass("hide");
						$("#filters").addClass("hide");
					}
					else
					{
						obj.options = data.Options;
						obj.buildOptionList();
					}
				}
				else
				{
					Misc.errorMessage(data.Error.Message + " (" + data.Error.Code + ")");
				}

				$("#pageLoading").hide();
			},
			function(xhr)
			{
				if (xhr.status == 429)
				{
					Misc.errorMessage("Too Many Requests");
				}
				else
				{
					Misc.errorMessage("Error loading options");
				}

				$("#pageLoading").hide();
			},
			"");
	}

	addFunds(optionID, amount, random, token, button)
	{
		var obj = this;

		$(button).prop('disabled', true);
		$("#pageLoading").show();

		Security.AJAX(
			"/services/savings/add-funds.php",
			{
				"optionID": optionID,
				"amount": amount,
				"random": random
			},
			"POST",
			function(data)
			{
				if (data.Error.Code == 0)
				{
					Misc.confirmMessage("Success", "Funds successfully added", "success", false)
					.then((result) =>
					{
						if (result.value)
						{
							obj.loadOptions();
						}
					});
				}
				else
				{
					Misc.errorMessage(data.Error.Message + " (" + data.Error.Code + ")");
				}

				$("#pageLoading").hide();
				$(button).prop('disabled', false);
			},
			function(xhr)
			{
				if (xhr.status == 429)
				{
					Misc.errorMessage("Too Many Requests");
				}
				else
				{
					Misc.errorMessage("Error Adding to Savings");
				}

				$("#pageLoading").hide();
				$(button).prop('disabled', false);
			},
			token);
	}

	claimRewards(optionID, random, token, button)
	{
		var obj = this;

		$(button).prop('disabled', true);
		$("#pageLoading").show();

		Security.AJAX(
			"/services/savings/claim-rewards.php",
			{
				"optionID": optionID,
				"random": random
			},
			"POST",
			function(data)
			{
				if (data.Error.Code == 0)
				{
					Misc.confirmMessage("Success", "Rewards successfully claimed", "success", false)
					.then((result) =>
					{
						if (result.value)
						{
							obj.loadOptions();
						}
					});
				}
				else
				{
					Misc.errorMessage(data.Error.Message + " (" + data.Error.Code + ")");
				}

				$("#pageLoading").hide();
				$(button).prop('disabled', false);
			},
			function(xhr)
			{
				if (xhr.status == 429)
				{
					Misc.errorMessage("Too Many Requests");
				}
				else
				{
					Misc.errorMessage("Error Claiming Rewards");
				}

				$("#pageLoading").hide();
				$(button).prop('disabled', false);
			},
			token);
	}

	claimExit(optionID, random, token, button)
	{
		var obj = this;

		$(button).prop('disabled', true);
		$("#pageLoading").show();

		Security.AJAX(
			"/services/savings/claim-exit.php",
			{
				"optionID": optionID,
				"random": random
			},
			"POST",
			function(data)
			{
				if (data.Error.Code == 0)
				{
					Misc.confirmMessage("Success", "Capital & Rewards successfully claimed", "success", false)
					.then((result) =>
					{
						if (result.value)
						{
							obj.loadOptions();
						}
					});
				}
				else
				{
					Misc.errorMessage(data.Error.Message + " (" + data.Error.Code + ")");
				}

				$("#pageLoading").hide();
				$(button).prop('disabled', false);
			},
			function(xhr)
			{
				if (xhr.status == 429)
				{
					Misc.errorMessage("Too Many Requests");
				}
				else
				{
					Misc.errorMessage("Error Claiming & Exiting");
				}

				$("#pageLoading").hide();
				$(button).prop('disabled', false);
			},
			token);
	}

}
